var UploadResumesTransactionCandidatesModalController = /** @class */ (function () {
    /*@ngInject*/
    function UploadResumesTransactionCandidatesModalController($rootScope, resumeService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.resumeService = resumeService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        // this.countsObject = this.resolve.countsObject;
        // this.countType = this.resolve.countType;
    }
    UploadResumesTransactionCandidatesModalController.prototype.$onInit = function () {
        var _this = this;
        this.countsObject = this.resolve.countsObject;
        this.countType = this.resolve.countType;
        this.resumeProcessedObject = this.resolve.resumeProcessedObject;
        this.resumeProcessedActivity = this.resolve.activity;
        this.modalType = this.resolve.modalType;
        this.activityMap = this.resolve.activityMap;
        this.jobBoarPulledCandidatesObject = this.resolve.jobBoarPulledCandidatesObject;
        this.candidates = [];
        this.userId = this.$rootScope.userDetails.id;
        this.candidatesQueryFilter = undefined;
        this.candidatesLoadedFlag = false;
        this.label = '';
        this.unProcessedCandidatesDownloadFileName = '';
        this.totalCandidatesInContainer = 3;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        if (this.countType == 'Matched') {
            this.label = 'Matched Candidates';
            this.candidates = this.countsObject.matchedCandidateIdAndNames;
        }
        else if (this.countType == 'UnMatched') {
            this.label = 'Unmatched Candidates';
            this.candidates = this.countsObject.unMatchedCandidateIdAndNames;
        }
        else if (this.countType == 'ManuallyMatched') {
            this.label = 'Manually Matched Candidates';
            this.candidates = [];
        }
        else if (this.countType == 'Uploaded') {
            this.label = 'Uploaded Candidates';
            this.candidates = _.unique(_.union(this.countsObject.matchedCandidateIdAndNames, this.countsObject.unMatchedCandidateIdAndNames), 'candidateId');
        }
        if (this.modalType === 'resumeProcessed') {
            this._setResumeProcessedModal();
        }
        if (this.modalType === 'jobBoardPull') {
            this._setJobBoardPullModal();
        }
        angular.forEach(this.candidates, function (val, key) {
            val.id = val.candidateId;
            val.context = "uploadResumesTransactionModal";
            if (key % _this.totalCandidatesInContainer == 0) {
                val.uploadResumePopoverPosition = 'bottom-left';
            }
            else if ((key + 1) % _this.totalCandidatesInContainer == 0) {
                val.uploadResumePopoverPosition = 'bottom-right';
            }
            else {
                val.uploadResumePopoverPosition = 'bottom';
            }
        });
        this.candidatesLoadedFlag = true;
    };
    UploadResumesTransactionCandidatesModalController.prototype._setResumeProcessedModal = function () {
        switch (this.resumeProcessedActivity) {
            case "Uploaded":
                this.label = 'Uploaded Candidates';
                this.candidates = _.unique(_.union(this.resumeProcessedObject.update ? this.resumeProcessedObject.update.matchedCandidateIdAndNames : [], this.resumeProcessedObject.update ? this.resumeProcessedObject.update.unMatchedCandidateIdAndNames : [], this.resumeProcessedObject.create ? this.resumeProcessedObject.create.matchedCandidateIdAndNames : [], this.resumeProcessedObject.create ? this.resumeProcessedObject.create.unMatchedCandidateIdAndNames : []), 'candidateId');
                break;
            case "Created":
                this.label = 'Created Candidates';
                this.candidates = _.unique(_.union(this.resumeProcessedObject.create.matchedCandidateIdAndNames, this.resumeProcessedObject.create.unMatchedCandidateIdAndNames), 'candidateId');
                break;
            case "CreatedMatched":
                this.label = 'Created Matched Candidates';
                this.candidates = this.resumeProcessedObject.create.matchedCandidateIdAndNames;
                break;
            case "CreatedUnMatched":
                this.label = 'Created Unmatched Candidates';
                this.candidates = this.resumeProcessedObject.create.unMatchedCandidateIdAndNames;
                break;
            case "Updated":
                this.label = 'Updated Candidates';
                this.candidates = _.unique(_.union(this.resumeProcessedObject.update.matchedCandidateIdAndNames, this.resumeProcessedObject.update.unMatchedCandidateIdAndNames), 'candidateId');
                break;
            case "UpdatedMatched":
                this.label = 'Updated Matched Candidates';
                this.candidates = this.resumeProcessedObject.update.matchedCandidateIdAndNames;
                break;
            case "UpdatedUnMatched":
                this.label = 'Updated Unmatched Candidates';
                this.candidates = this.resumeProcessedObject.update.unMatchedCandidateIdAndNames;
                break;
            case "NotProcessed":
                this.label = 'Not Processed Candidates';
                this.candidates = _.cloneDeep(this.resumeProcessedObject.unProcessedCandidates);
                this._massageNonProcessedCandidatesData(this.candidates);
                break;
            default:
                break;
        }
    };
    UploadResumesTransactionCandidatesModalController.prototype._setJobBoardPullModal = function () {
        switch (this.resumeProcessedActivity) {
            case "pulled":
                this.label = 'Pulled Candidates';
                this.candidates = this.jobBoarPulledCandidatesObject.candidates;
                break;
            case "autoMatched":
                this.label = 'Matched Candidates';
                this.candidates = this.jobBoarPulledCandidatesObject.create.matchedCandidateIdAndNames;
                break;
            case "unMatched":
                this.label = 'Unmatched Candidates';
                this.candidates = this.jobBoarPulledCandidatesObject.create.unMatchedCandidateIdAndNames;
                break;
            case "manuallyMatched":
                this.label = 'Manually Matched Candidates';
                this.candidates = this.jobBoarPulledCandidatesObject.create.manuallyMatchedCandidateIdAndNames;
                break;
            case "updatedCandidates":
                this.label = 'Updated Candidates';
                this.candidates = this.jobBoarPulledCandidatesObject.create.updatedCandidateIdAndNames;
                break;
            case "resumeNotProcessed":
                this.label = 'Resume Not Processed Candidates';
                this.candidates = this.jobBoarPulledCandidatesObject.unProcessedCandidates ? _.cloneDeep(this.jobBoarPulledCandidatesObject.unProcessedCandidates) : [];
                this._massageNonProcessedCandidatesData(this.candidates);
                break;
            default:
                break;
        }
    };
    UploadResumesTransactionCandidatesModalController.prototype._massageNonProcessedCandidatesData = function (candidates) {
        candidates.forEach(function (candidate) {
            if (candidate.firstName && candidate.lastName) {
                candidate.name = candidate.firstName + " " + candidate.lastName;
            }
            else if (!candidate.firstName && !candidate.lastName) {
                candidate.name = 'Not Available';
            }
            else {
                candidate.name = !candidate.firstName ? candidate.lastName : candidate.firstName;
            }
            candidate.firstName = candidate.firstName ? candidate.firstName : 'Not Available';
            candidate.lastName = candidate.lastName ? candidate.lastName : 'Not Available';
            candidate.email = candidate.email ? candidate.email : 'Not Available';
            candidate.phone = candidate.phone ? candidate.phone : 'Not Available';
            if (candidate.mobilePhoneCountryCodePresent) {
                var phoneNumberObject = libphonenumber.parse(candidate.phone.toString());
                if (phoneNumberObject.phone !== undefined) {
                    candidate.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                }
            }
            candidate.score = Math.floor(parseFloat(candidate.score));
        });
    };
    UploadResumesTransactionCandidatesModalController.prototype.downloadAllResumes = function () {
        var _this = this;
        var unprocessedCandidateList = [];
        this.resumeProcessedObject.unProcessedCandidates.forEach(function (candidate) {
            unprocessedCandidateList.push({ resumeId: candidate.resumeId, failureReason: candidate.failureReason });
        });
        var unprocessedCandidateObj = {
            candidateUnProcessedResumeList: unprocessedCandidateList
        };
        this.resumeService.downloadAllResumes(unprocessedCandidateObj, function (data) {
            if (data.status == 200) {
                var fileName = '';
                fileName = data.headers.get('content-disposition').split(';')[1].split('=')[1].slice(1).slice(0, -1);
                _this.unProcessedCandidatesDownloadFileName = fileName ? fileName : 'resumesnotprocessed.zip';
                saveAs(data.body, _this.unProcessedCandidatesDownloadFileName);
            }
            else {
                _this.alertsAndNotificationsService.showBannerMessage('Download Zip file failed', 'danger');
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.error, 'danger');
        });
    };
    UploadResumesTransactionCandidatesModalController.prototype.saveCallback = function (contactDetails) {
        this.callbackObject.callbackType = "save";
        this.callbackObject.entity = contactDetails;
        this.closeModal();
    };
    UploadResumesTransactionCandidatesModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    UploadResumesTransactionCandidatesModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return UploadResumesTransactionCandidatesModalController;
}());
UploadResumesTransactionCandidatesModalController.$inject = ['$rootScope', 'resumeService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './upload-resumes-transaction-candidates-modal.html';
import * as TEMPLATE from 'raw-loader!./upload-resumes-transaction-candidates-modal.html';
export var UploadResumesTransactionCandidatesModalComponent = {
    selector: 'uploadResumesTransactionCandidatesModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: UploadResumesTransactionCandidatesModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/uploadResumesTransactionCandidatesModal/upload-resumes-transaction-candidates-modal.html'
    }
};
//# sourceMappingURL=upload-resumes-transaction-candidates-modal.component.js.map